import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { setVisitOverviewFetching, setVisitOverview } from './actions';

import { HealAPI } from '../../healApi';
import { RootState } from '../types';
import { toShortDateString } from '../../util/Date';
import { history } from '../store';

function* fetchVisitOverview(): any {
  let state: RootState = yield select((s) => s);
  if (!state.markets.markets.data) {
    yield take('MARKETS_SET_MARKETS');
    state = yield select((s) => s);
  }

  const date = (history.location.state || ({} as any)).date || toShortDateString(new Date());
  if ((state.dashboard.visitsOverview[date]?.isFetching || state.dashboard.visitsOverview[date]?.data) && date !== toShortDateString(new Date())) {
    // Don't re-fetch if the data is already present - past data will not change
    // Exception: current day should always do a fetch.
    return;
  }

  yield put(setVisitOverviewFetching(date, true));
  const result = yield call(HealAPI.fetchDashboardOverview, date);
  yield put(setVisitOverview(date, result.data));
  yield put(setVisitOverviewFetching(date, false));
}

export function* dashboardFlow() {
  yield takeEvery('PAGE_DID_MOUNT/Dashboard', fetchVisitOverview);
}
